import { createFeaturedStats } from 'molecules/Stats/config';

import type { Input } from '@builder.io/sdk';

export const metricsFields = [
  {
    name: 'backgroundColor',
    type: 'string',
    enum: ['mystic', 'white'],
    defaultValue: 'white',
  },
  {
    name: 'eyebrow',
    type: 'string',
  },
  {
    name: 'body',
    type: 'richText',
  },
  {
    name: 'removeSpaceBetween',
    type: 'boolean',
    defaultValue: false,
  },
  ...createFeaturedStats(),
] as const satisfies DeepReadonly<Input[]>;

const metricsConfig = {
  name: 'Metrics',
  inputs: metricsFields,
};

export type MetricsProps = GenerateBuilder<typeof metricsFields>;

export default metricsConfig;
